import { render } from "./BlogPostCard.vue?vue&type=template&id=09a2017c&scoped=true"
import script from "./BlogPostCard.vue?vue&type=script&lang=js"
export * from "./BlogPostCard.vue?vue&type=script&lang=js"

import "./BlogPostCard.vue?vue&type=style&index=0&id=09a2017c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a2017c"]])

export default __exports__